export const createSearchSlice = (set, get) => ({
    searchValue: '',
    setSearchValue: (value) => {
        set(() => ({ searchValue: value }));
        get().calculateRows();
    },
});
